import { Badge, Button, Card, Checkbox, Col, Flex, Image, Row, Space, Spin, Tooltip, Typography } from 'antd';
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from 'react';
import iconAgent from '../../../assets/images/diagram/ic-agent.svg';
import IconBan from '../../../assets/images/diagram/ic-ban.svg';
import iconBooking from '../../../assets/images/diagram/ic-booking.svg';
import iconCompanyReserve from '../../../assets/images/diagram/ic-company-reserve.svg';
import iconCarGroup from '../../../assets/images/diagram/ic-company.svg';
import IcEdit from '../../../assets/images/diagram/ic-edit-v2.svg';
import IcEditTicket from '../../../assets/images/diagram/ic-edit.svg';
import IconReserve from '../../../assets/images/diagram/ic-hold.svg';
import IcLock from '../../../assets/images/diagram/ic-lock.svg';
import IcMoveTicket from '../../../assets/images/diagram/ic-move-ticket.svg';
import iconNew from '../../../assets/images/diagram/ic-new.svg';
import iconOpenApi from '../../../assets/images/diagram/ic-openapi-reserve.svg';
import IconOpenApi from '../../../assets/images/diagram/ic-openapi.svg';
import IconPayment from '../../../assets/images/diagram/ic-payment.svg';
import IcPrintTicket from '../../../assets/images/diagram/ic-print.svg';
import IcSendMail from '../../../assets/images/diagram/ic-send-mail.svg';
import icSold from '../../../assets/images/diagram/ic-sold.svg';
import iconAgentReserve from '../../../assets/images/diagram/icon-agent-reserve.svg';
import iconPaid from '../../../assets/images/diagram/icon-paid.svg';
import iconUnPaid from '../../../assets/images/diagram/icon-unpaid.svg';
import { typeSeatItems } from '../../../components/BusTypeMatrix';
import { Constant, DateFormat, USER_GROUP } from '../../../config/constant';
import { formattedPrice, imageStatusTicket } from '../../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setReloadDetail } from '../../../redux/slice/authSlice';
import { getDataBookingSeat } from '../../../redux/slice/bookings/bookingTicketSlice';
import { getAssistBookingSelector } from '../../../redux/slice/bookings/getAssistBookingSlice';
import { listBookingSelector, resetDataMoveTicket } from '../../../redux/slice/bookings/listBooking';
import {
  getBookingDetailSeat,
  getListBookingDetail,
  listDetailTicketSelector,
} from '../../../redux/slice/bookings/listDetailTicketSlice';
import {
  moveTicketSelector,
  postMoveTicket,
  resetListAvailableSeat,
  resetMoveTicket,
} from '../../../redux/slice/bookings/moveTicketSlice';
import { setIsPrintTicket } from '../../../redux/slice/bookings/printTicketSlice';
import { getSendBookingMail, updateStatusBooking } from '../../../redux/slice/bookings/updateBooking';
import { getPriceScheduleReason } from '../../../utils/helpers';
import ModalChangeBooking from '../changeBooking/ModalChangeBooking';
import ModalBooking from '../ModalBooking';
import ModalExportTicket from '../ModalExportTicket';
import ModalHistoryBooking from '../ModalHistoryBooking';
import ModalPrintTicket from '../tickets/ModalPrintTicket';
import CountdownComponent from './Countdown';

function BusDiagramBookingRender({
  listBooking,
  statusFloor,
  busTypeData,
  group,
  searchDateBooking,
  dateSelect,
  closeBefore,
  isMoveTicket,
  dataMoveTicket,
  setBusTypeData,
  refs,
  isShowAllFloor,
  handleLockMultiBooking,
  handleCreateMultiBooking,
  handleCreateBooking,
  listBookingRender,
  isShowNewBooking,
  loadingBookingRender,
  setOpenModalBookingDetail,
  setIsDetail,
  isBooking,
  formSearch,
  isDetail,
  loading,
  listBookingDetailSeat,
  isMoveTicketWaiting,
  isWaitingCustomerList = false,
  listCustomerBooking,
}: any) {
  const {
    loadingListBooking: loadingDetailList,
    listBookingDetail,
    loading: loadingDetail,
  } = useAppSelector(listDetailTicketSelector);
  const { status: statusMoveTicket, listAvailableSeat } = useAppSelector(moveTicketSelector);
  const { listFreeSeat, listAssistBooking } = useAppSelector(getAssistBookingSelector);

  const { loadingCustomerBooking } = useAppSelector(listBookingSelector);
  const now = dayjs();
  const date = dayjs(new Date());
  const isOpenBus = closeBefore ? dayjs(closeBefore).isAfter(now) : null;
  const [isHoveredReserve, setIsHoveredReserve] = useState('');
  const [isHoveredPayment, setIsHoveredPayment] = useState('');
  const [isHoveredOpenApi, setIsHoveredOpenApi] = useState('');
  const [openModalHistory, setOpenModalHistory] = useState(false);
  const [openModalBooking, setOpenModalBooking] = useState(false);
  const [openModalExportTicket, setOpenModalExportTicket] = useState(false);
  const [selectedSeatChangeBooking, setSelectedSeatChangeBooking] = useState<string[]>([]);
  const [openModalChangeBooking, setOpenModalChangeBooking] = useState(false);
  const [openModalPrint, setOpenModalPrint] = useState(false);
  const dispatch = useAppDispatch();
  const handleChangeTicket = useCallback(
    (rowIndex: number, colIndex: number, floor?: number) => {
      if (!isShowAllFloor || listBooking?.schedule?.bus_type?.seat_map?.count_floor === 1) {
        setBusTypeData((prevMatrix: any) => {
          const newMatrix = JSON.parse(JSON.stringify(prevMatrix));
          const seat = newMatrix[`floor${statusFloor}`][rowIndex][colIndex];
          seat.selected = !seat.selected;
          return newMatrix;
        });
      } else {
        if (floor === 1) {
          setBusTypeData((prevMatrix: any) => {
            const newMatrix = JSON.parse(JSON.stringify(prevMatrix));
            const seat = newMatrix[`floor1`][rowIndex][colIndex];
            seat.selected = !seat.selected;
            return newMatrix;
          });
        } else {
          setBusTypeData((prevMatrix: any) => {
            const newMatrix = JSON.parse(JSON.stringify(prevMatrix));
            const seat = newMatrix[`floor2`][rowIndex][colIndex];
            seat.selected = !seat.selected;
            return newMatrix;
          });
        }
      }
    },
    [statusFloor, isShowAllFloor, listBooking],
  );
  const handleLockBooking = (name: string) => {
    if (listBooking?.schedule?.id && name) {
      const lockBookingData = {
        schedule_id: listBooking.schedule.id,
        seat_number: [name],
        depart_date: searchDateBooking,
        status: 1,
      };
      dispatch(updateStatusBooking(lockBookingData));
    }
  };
  const handleUnLockBooking = (name: string) => {
    if (listBooking?.schedule?.id && name) {
      const lockBookingData = {
        schedule_id: listBooking.schedule.id,
        seat_number: [name],
        depart_date: searchDateBooking,
        status: 0,
      };
      dispatch(updateStatusBooking(lockBookingData));
    }
  };
  const getDetailBooking = (name: string) => {
    setIsDetail(true);
    if (listBooking?.schedule?.id && name) {
      dispatch(
        getBookingDetailSeat({
          seat_number: name,
          is_diagram: true,
          schedule_id: listBooking?.schedule?.id,
          depart_date: searchDateBooking,
        }),
      );
    }
    setOpenModalBookingDetail(true);
  };
  const getSeatStyle = (seatFloors: any, seatEntries?: any) => {
    switch (true) {
      case seatFloors?.type === Constant.DRIVER_SEAT || seatFloors?.type === Constant.EXTRA_DRIVER_SEAT:
        return {
          backgroundColor: 'transparent',
          minHeight: 'unset',
          height: '100px',
        };

      case group === USER_GROUP.AGENT && seatEntries?.id: {
        switch (true) {
          case (seatEntries?.payment_method === 'reserve' || seatEntries?.payment_method === 'paid_at_company') &&
            seatEntries?.status !== 'locked' &&
            seatEntries?.status !== 'paid':
            return { backgroundColor: '#ffe296' };

          case (seatEntries?.payment_method === 'cash' ||
            seatEntries?.payment_method === 'bank_transfer' ||
            seatEntries?.payment_method === 'agent_balance' ||
            seatEntries?.payment_method === 'paid_at_company' ||
            seatEntries?.status === 'paid') &&
            seatEntries?.status !== 'locked':
            return { backgroundColor: '#99d6a2' };

          default:
            return {};
        }
      }

      default:
        return {};
    }
  };
  const getInfoSingleDetail = (seatEntriesData: any) => {
    if (seatEntriesData?.bookings?.reserve?.details?.length) {
      return seatEntriesData.bookings.reserve.details[0];
    }
    if (seatEntriesData?.bookings?.paid?.details?.length) {
      return seatEntriesData.bookings.paid.details[0];
    }
    if (seatEntriesData?.bookings?.open_api?.details?.length) {
      return seatEntriesData.bookings.open_api.details[0];
    } else {
      return undefined;
    }
  };
  const handleEditBooking = (key: string, ticket_code: string, id: number, seatInfo: any, seat_name: string) => {
    if (key === 'Chỉnh sửa' && ticket_code) {
      setOpenModalBooking(true);
      setIsDetail(true);
      dispatch(getListBookingDetail({ ticket_code: ticket_code }));
    }
    if (key === 'Gửi mail' && id) {
      dispatch(getSendBookingMail(id));
    }
    if (key === 'In vé' && id) {
      dispatch(setReloadDetail());
      setOpenModalPrint(true);
      dispatch(getListBookingDetail({ ticket_code: ticket_code }));
      dispatch(setIsPrintTicket(true));
    }
    if (key === 'Chuyển vé' && ticket_code) {
      setOpenModalChangeBooking(true);
      setSelectedSeatChangeBooking([seat_name]);
      dispatch(
        getDataBookingSeat({
          ticket_codes: [ticket_code],
        }),
      );
    }
  };
  const cancelModalBooking = () => {
    setOpenModalBooking(false);
  };
  const handleOkChangeBooking = () => {};
  const handleOkModalBooking = () => {};
  const cancelChangBookingModal = () => {
    setOpenModalChangeBooking(false);
    dispatch(resetListAvailableSeat());
    dispatch(resetMoveTicket());
    dispatch(resetDataMoveTicket());
  };

  const handleChangeBooking = (seatName: string[]) => {
    setSelectedSeatChangeBooking(seatName);
    dispatch(
      getDataBookingSeat({
        seat_numbers: seatName,
        schedule_id: listBooking?.schedule?.id,
        depart_date: searchDateBooking,
      }),
    );
    setOpenModalChangeBooking(true);
  };

  const handleMoveTicket = (seat_number: string) => {
    if (
      isMoveTicketWaiting &&
      listAvailableSeat?.available_seats?.length &&
      listAvailableSeat?.available_seats?.includes(seat_number)
    ) {
      dispatch(
        postMoveTicket({
          old_ticket_code: dataMoveTicket?.ticket_code,
          depart_date: dataMoveTicket?.depart_date,
          segment_id: dataMoveTicket?.segment_id,
          seat_number: seat_number,
          pickup_location_id: dataMoveTicket?.pickup_location_id,
          drop_off_location_id: dataMoveTicket?.drop_off_location_id,
          pickup_extra: dataMoveTicket?.pickup_extra,
          drop_off_extra: dataMoveTicket?.drop_off_extra,
        }),
      );
    }
  };
  const cancelModalHistory = () => {
    setOpenModalHistory(false);
  };
  const cancelModalPrint = () => {
    dispatch(setReloadDetail());
    setOpenModalPrint(false);
    dispatch(setIsPrintTicket(false));
  };
  useEffect(() => {
    if (statusMoveTicket === Constant.DEFAULT_STATUS) {
      setOpenModalChangeBooking(false);
    }
  }, [statusMoveTicket]);

  return (
    <Spin spinning={isMoveTicketWaiting ? loadingCustomerBooking : loadingBookingRender}>
      <Flex gap={24} className="mt-4">
        {isShowAllFloor ||
        listBooking?.schedule?.bus_type?.seat_map?.count_floor === 1 ||
        statusFloor === 1 ||
        (statusFloor !== 2 && !isShowAllFloor) ? (
          <div
            className={`${
              (statusFloor === 1 && !isShowAllFloor) || listBooking?.schedule?.bus_type?.seat_map?.count_floor === 1
                ? 'w-100'
                : 'w-50'
            }`}
          >
            <Typography className="title-box-floor1">Tầng 1</Typography>
            {listBooking?.schedule?.bus_type?.seat_map[`floor1`]?.map((rowSeats: any, rowIndex: number) => {
              const nonEmptySeatsCount = rowSeats.filter((seat: any) => seat.name || seat.type !== 0).length;
              const isSingleSeatRow = nonEmptySeatsCount === 1;
              const firstRow = rowIndex === 0 && rowSeats;
              const isSingleSeat =
                firstRow?.length &&
                firstRow?.filter((item: any) => item?.name && item?.type <= Constant.EXTRA_DRIVER_SEAT)?.length === 1;
              return (
                <Row
                  gutter={[12, 12]}
                  key={rowIndex}
                  className="mt-2"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${nonEmptySeatsCount}, 1fr)`,
                  }}
                >
                  {rowSeats?.map((seatFloors: any, colIndex: number) => {
                    const seatEntries =
                      isWaitingCustomerList &&
                      !!listCustomerBooking?.bookings?.data &&
                      listCustomerBooking?.bookings?.data[seatFloors?.name]
                        ? listCustomerBooking?.bookings?.data[seatFloors?.name]
                        : listBookingRender?.booking?.data && listBookingRender?.booking?.data[seatFloors?.name]
                        ? listBookingRender?.booking?.data[seatFloors?.name]
                        : undefined;

                    // const seatEntriesExpired = bookingData?.find((entry: any) => entry.seat_number === seatFloors.name);
                    const seatCustomerEntries = listBooking?.customers?.data?.find(
                      (entry: any) => entry.seat_number === seatFloors.name,
                    );
                    // const seatBooking =
                    //   Array.isArray(listBooking?.schedule?.agent_seats) &&
                    //   listBooking?.schedule?.agent_seats?.includes(seatFloors?.name);
                    const selectedSeatNames = isShowAllFloor
                      ? ['floor1', 'floor2'].flatMap((floor) =>
                          busTypeData?.[floor]?.flatMap(
                            (row: any) =>
                              !date.isAfter(listBooking?.travel_info?.depart_time, 'day') &&
                              row.filter((seat: any) => seat.selected).map((seat: any) => seat.name),
                          ),
                        )
                      : busTypeData?.[`floor1`].flatMap(
                          (row: any) =>
                            !date.isAfter(listBooking?.travel_info?.depart_time, 'day') &&
                            row.filter((seat: any) => seat.selected).map((seat: any) => seat.name),
                        );
                    const isLocked =
                      listBookingRender?.locked_booking?.length &&
                      listBookingRender?.locked_booking?.find((booking: any) => booking === seatFloors?.name);
                    const checkAvailableSeat = (() => {
                      const seatsData = listBookingRender?.booking?.data;

                      if (!seatsData || !Array.isArray(selectedSeatNames) || selectedSeatNames.length < 1) {
                        return undefined;
                      }
                      const validSeats = selectedSeatNames.filter((seatName) => seatName in seatsData);

                      if (validSeats.length === 0) {
                        return true;
                      }
                      return validSeats.every((seatName) => seatsData[seatName]?.is_available === true);
                    })();

                    return (
                      (seatFloors.name || seatFloors.type !== Constant.DEFAULT_SEAT) && (
                        <Col
                          key={colIndex}
                          onClick={() =>
                            seatFloors.type > Constant.EXTRA_DRIVER_SEAT &&
                            seatFloors.name &&
                            ((seatEntries && !isDetail) || !seatEntries) &&
                            !isLocked &&
                            !isWaitingCustomerList &&
                            (listAssistBooking?.length && listFreeSeat?.length
                              ? listFreeSeat?.includes(seatFloors?.name)
                              : true) &&
                            !seatEntries?.is_lock &&
                            !(isMoveTicketWaiting && dataMoveTicket?.ticket_code) &&
                            (group !== USER_GROUP.AGENT ||
                              (group === USER_GROUP.AGENT &&
                                searchDateBooking &&
                                (seatEntries || !seatEntries) &&
                                listBooking?.schedule?.agent_seats?.includes(seatFloors?.name))) &&
                            handleChangeTicket(rowIndex, colIndex, 1)
                          }
                          ref={(el) => {
                            refs.current[seatEntries?.new_booking?.ticket_code] = el;
                          }}
                        >
                          <Checkbox className="checkbox-diagram d-none" checked={seatFloors.selected} />
                          <Card
                            onClick={() =>
                              isMoveTicketWaiting &&
                              listAvailableSeat?.available_seats?.length &&
                              dataMoveTicket?.ticket_code &&
                              seatFloors?.type > 2 &&
                              (group !== USER_GROUP.AGENT ||
                                (group === USER_GROUP.AGENT &&
                                  (searchDateBooking &&
                                  listBooking?.schedule?.agent_seats_custom &&
                                  listBooking?.schedule?.agent_seats_custom[searchDateBooking]
                                    ? listBooking?.schedule?.agent_seats_custom[searchDateBooking]?.includes(
                                        seatFloors?.name,
                                      ) && !listBooking?.booked_seat?.includes(seatFloors?.name)
                                    : listBooking?.schedule?.agent_seats?.includes(seatFloors?.name) &&
                                      !listBooking?.booked_seat?.includes(seatFloors?.name)))) &&
                              handleMoveTicket(seatFloors?.name)
                            }
                            className={`mt-1 ant-card-diagram diagram
                        ${isSingleSeat ? 'w-60' : isSingleSeatRow && 'w-30'}
                         ${seatEntries ? 'booked' : ''}
                         ${
                           listBooking?.count_segment === 1 && seatEntries?.bookings?.open_api?.details?.length
                             ? 'open_api'
                             : ''
                         }
                         ${
                           seatFloors?.type === Constant.DRIVER_SEAT || seatFloors?.type === Constant.EXTRA_DRIVER_SEAT
                             ? 'driver'
                             : ''
                         }
                          ${
                            isMoveTicketWaiting && listAvailableSeat?.available_seats?.length
                              ? !listAvailableSeat?.available_seats?.includes(seatFloors?.name)
                                ? 'cursor-move ban'
                                : 'cursor-move'
                              : ''
                          }
                              ${
                                listAssistBooking?.length &&
                                listFreeSeat?.length &&
                                !listFreeSeat?.includes(seatFloors?.name)
                                  ? 'cursor-move ban'
                                  : ''
                              }
                         ${
                           (isLocked && !seatEntries) ||
                           (group === USER_GROUP.AGENT &&
                             searchDateBooking &&
                             !listBooking?.schedule?.agent_seats?.includes(seatFloors?.name))
                             ? 'driver ban'
                             : ''
                         }
                             ${seatEntries?.is_lock ? 'locked' : ''}
                              ${
                                busTypeData &&
                                busTypeData?.[`floor1`] &&
                                busTypeData?.[`floor1`][rowIndex] &&
                                busTypeData?.[`floor1`][rowIndex][colIndex] &&
                                busTypeData?.[`floor1`][rowIndex][colIndex]?.name === seatFloors?.name &&
                                busTypeData?.[`floor1`][rowIndex][colIndex]?.selected &&
                                seatFloors.type > Constant.EXTRA_DRIVER_SEAT &&
                                !seatEntries?.is_lock &&
                                // !seatEntries &&
                                !isLocked &&
                                !isWaitingCustomerList &&
                                (listAssistBooking?.length && listFreeSeat?.length
                                  ? listFreeSeat?.includes(seatFloors?.name)
                                  : true) &&
                                (group !== USER_GROUP.AGENT ||
                                  (group === USER_GROUP.AGENT &&
                                    searchDateBooking &&
                                    // !seatEntries &&
                                    listBooking?.schedule?.agent_seats?.includes(seatFloors?.name))) &&
                                (listBooking?.trip?.status !== 'departed' || !isBooking) &&
                                ((!isOpenBus && listBooking?.trip?.status !== 'canceled') || isOpenBus) &&
                                !(
                                  dateSelect > dayjs(listBooking?.schedule?.open_before_day) ||
                                  listBooking?.schedule?.open_before === 0
                                ) &&
                                !(isMoveTicket && dataMoveTicket?.ticket_code)
                                  ? 'selected'
                                  : ''
                              }
                       ${
                         (seatFloors.type === Constant.DRIVER_SEAT ||
                           seatFloors.type === Constant.EXTRA_DRIVER_SEAT ||
                           seatEntries?.status === 'locked' ||
                           (isWaitingCustomerList &&
                             !(isMoveTicketWaiting && listAvailableSeat?.available_seats?.length)) ||
                           (group === USER_GROUP.AGENT &&
                             searchDateBooking &&
                             !listBooking?.schedule?.agent_seats?.includes(seatFloors?.name) &&
                             (listBooking?.trip?.status !== 'departed' || !isBooking) &&
                             ((!isOpenBus && listBooking?.trip?.status !== 'canceled') || isOpenBus) &&
                             listBooking?.trip?.status !== 'canceled' &&
                             !(
                               dateSelect > dayjs(listBooking?.schedule?.open_before_day) ||
                               listBooking?.schedule?.open_before === 0
                             ))) &&
                         !seatEntries
                           ? 'ban'
                           : ''
                       }
                          `}
                            style={getSeatStyle(seatFloors, seatEntries)}
                            actions={[]}
                            cover={
                              <div
                                className={`bus-diagram-card ${seatFloors?.type < Constant.NORMAL_SEAT ? 'driver' : ''}
                                  ${seatEntries?.total_paid ? 'booked' : ''}
                                  `}
                              >
                                {seatEntries?.is_lock ? (
                                  <>
                                    <div className="header-card-diagram locked">
                                      <Typography className="fw-600 title-card">
                                        <Image
                                          src={
                                            typeSeatItems?.find((item: any) => +item?.id === +seatFloors.type)?.image
                                          }
                                          alt=""
                                          height={32}
                                          preview={false}
                                          className={`img-type-seat`}
                                        />
                                        <span className="seat-name-booking d-flex items-center mb-0">
                                          {seatFloors.name}
                                        </span>
                                      </Typography>
                                    </div>
                                    <div className="block-content">
                                      <Button
                                        className="btn btn-block"
                                        onClick={() => handleUnLockBooking(seatFloors?.name)}
                                      >
                                        <img src={IcLock} alt="" />
                                      </Button>
                                      <Typography className="fw-500 fs-16 mt-2">Ghế này đã bị khoá!</Typography>
                                      <Typography className="fs-12 fw-400">{`Bởi ${seatEntries?.staff_lock}`}</Typography>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="header-card-diagram">
                                      <Typography
                                        className={`fw-600 ${
                                          seatEntries?.orderer?.name ? 'is-booking' : ''
                                        } title-card  items-center space-between w-100`}
                                      >
                                        <Flex align="center" justify="center" gap={10}>
                                          <div
                                            className="title-seat-diagram"
                                            style={
                                              seatFloors?.type === Constant.DRIVER_SEAT ||
                                              seatFloors?.type === Constant.EXTRA_DRIVER_SEAT
                                                ? {
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                  }
                                                : {}
                                            }
                                          >
                                            <Image
                                              src={
                                                typeSeatItems?.find((item: any) => +item?.id === +seatFloors.type)
                                                  ?.image
                                              }
                                              alt=""
                                              height={32}
                                              preview={false}
                                              className={`img-type-seat w-fit`}
                                            />
                                            <p
                                              className={`seat-name-booking ${
                                                seatFloors.type > Constant.EXTRA_DRIVER_SEAT ? 'ticket' : ''
                                              } `}
                                              style={
                                                seatFloors.type === Constant.EXTRA_DRIVER_SEAT ||
                                                seatFloors.type === Constant.DRIVER_SEAT
                                                  ? { marginBottom: 0 }
                                                  : {}
                                              }
                                            >
                                              {seatFloors.type > Constant.EXTRA_DRIVER_SEAT ? '' : seatFloors.name}
                                            </p>
                                          </div>
                                          {!listBooking?.contract?.code ? (
                                            <>
                                              {seatFloors?.type > Constant.EXTRA_DRIVER_SEAT && (
                                                <>
                                                  {listBooking?.count_segment === 1 ? (
                                                    <span className="seat-name-booking">
                                                      {` ${
                                                        seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                                        seatEntries?.new_booking?.ticket_code
                                                          ? seatEntries?.new_booking?.ticket_code
                                                          : seatFloors?.name
                                                      }  - ${
                                                        seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                                        seatEntries?.new_booking?.ticket_code
                                                          ? seatFloors?.name
                                                          : seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                                            typeSeatItems?.find(
                                                              (item: any) => +item?.id === +seatFloors.type,
                                                            )?.name
                                                      }`}
                                                    </span>
                                                  ) : (
                                                    <span className=" seat-name-booking">
                                                      {`${
                                                        seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                                        typeSeatItems?.find(
                                                          (item: any) => +item?.id === +seatFloors.type,
                                                        )?.name
                                                      } -  ${
                                                        seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                                        !seatEntries?.ticket_code
                                                          ? seatFloors?.name
                                                          : ''
                                                      }`}
                                                    </span>
                                                  )}
                                                </>
                                              )}
                                              {!(
                                                (seatEntries?.status === 'hold' || seatEntries?.status === 'reserve') &&
                                                (seatEntries?.source === 'openapi' || seatEntries?.source === 'company')
                                              ) ? (
                                                <span className="seat-name-booking ticket-code">
                                                  {seatEntries?.ticket_code
                                                    ? `${seatEntries?.ticket_code} - ${seatFloors?.name}`
                                                    : seatEntries?.ticket_code}
                                                </span>
                                              ) : (
                                                <span className="seat-name-booking ticket-code">
                                                  {seatFloors?.name}
                                                </span>
                                              )}
                                            </>
                                          ) : seatFloors?.type > Constant.EXTRA_DRIVER_SEAT ? (
                                            <p className={`seat-name-booking`}>{seatFloors?.name}</p>
                                          ) : (
                                            ''
                                          )}
                                          {listBooking?.count_segment === 1 && seatEntries?.new_booking?.expired_at ? (
                                            <div
                                              className="countdown-diagram"
                                              style={{
                                                position: 'absolute',
                                                top: '13px',
                                                right: '5px',
                                              }}
                                            >
                                              <CountdownComponent seatEntriesExpired={seatEntries?.new_booking} />
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                        </Flex>
                                        {seatEntries &&
                                        !seatEntries?.is_available &&
                                        listBooking?.count_segment !== 1 ? (
                                          <img src={icSold} alt="" />
                                        ) : (
                                          <></>
                                        )}
                                      </Typography>
                                    </div>

                                    <div className="block-info relative">
                                      <Typography className="fw-500 fs-14 mr-5 orderer-name">
                                        {seatEntries?.orderer?.name}
                                      </Typography>
                                      {seatFloors?.type === Constant.DRIVER_SEAT && (
                                        <>
                                          {listBooking?.trip?.drivers?.map((driver: any, index: number) => (
                                            <Typography className="fw-500 fs-16" key={index}>
                                              <span className="fw-600">{driver.name}</span> <br />
                                              <span> {driver.phone}</span>
                                            </Typography>
                                          ))}
                                        </>
                                      )}
                                      {seatFloors?.type === Constant.EXTRA_DRIVER_SEAT && (
                                        <>
                                          {listBooking?.trip?.extra_drivers?.map((driver: any, index: number) => (
                                            <Typography key={index} className="fw-500 fs-16">
                                              <span className="fw-600">{driver.name}</span> <br />
                                              <span>{driver.phone}</span>
                                            </Typography>
                                          ))}
                                        </>
                                      )}
                                      {seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                      seatEntries &&
                                      listBooking?.count_segment !== 1 ? (
                                        <Flex gap={20} className="mt-4 status-booking-block">
                                          <Space size="middle" className="relative block-info-booking">
                                            {seatEntries?.bookings?.reserve &&
                                            seatEntries?.bookings?.reserve?.details?.length ? (
                                              <div key={seatEntries?.ticket_code}>
                                                <Badge count={seatEntries?.bookings?.reserve?.details?.length}>
                                                  <img
                                                    src={IconReserve}
                                                    alt=""
                                                    onMouseOver={() =>
                                                      setIsHoveredReserve(
                                                        seatEntries?.bookings?.reserve?.details[0]?.id,
                                                      )
                                                    }
                                                    onMouseOut={() => setIsHoveredReserve('')}
                                                  />
                                                </Badge>
                                                {isHoveredReserve ===
                                                  seatEntries?.bookings?.reserve?.details[0]?.id && (
                                                  <div className="hover-info">
                                                    {seatEntries?.bookings?.reserve?.details &&
                                                      seatEntries?.bookings?.reserve?.details?.map(
                                                        (booking: any, index: number) => (
                                                          <Flex gap={16} align="center" key={`booking-${index}`}>
                                                            <div>
                                                              <p className="fs-16 fw-500 text-blue">
                                                                {booking?.ticket_code}
                                                              </p>
                                                              <div className="d-flex items-center gap-x-4">
                                                                <p
                                                                  className={`fs-14 fw-500`}
                                                                  style={{
                                                                    marginTop: '-5px',
                                                                  }}
                                                                >
                                                                  <img
                                                                    src={imageStatusTicket(booking, false, true, false)}
                                                                    alt=""
                                                                  />
                                                                </p>
                                                                <CountdownComponent seatEntriesExpired={booking} />
                                                              </div>
                                                            </div>
                                                            <div className="max-content">
                                                              <p className="fs-16 fw-500 text-blue">
                                                                {booking?.customer_name}
                                                              </p>
                                                              <p className="fs-14 fw-500 text-light-blue">{`${booking?.start_location} - ${booking?.end_location}`}</p>
                                                            </div>
                                                          </Flex>
                                                        ),
                                                      )}
                                                  </div>
                                                )}
                                              </div>
                                            ) : (
                                              <></>
                                            )}
                                          </Space>
                                          <Space size="middle">
                                            {seatEntries?.bookings?.paid &&
                                            seatEntries?.bookings?.paid?.details?.length ? (
                                              <div className="relative block-info-booking">
                                                <Badge count={seatEntries?.bookings?.paid?.details?.length}>
                                                  <img
                                                    src={IconPayment}
                                                    alt=""
                                                    onMouseOver={() =>
                                                      setIsHoveredPayment(seatEntries?.bookings?.paid?.details[0]?.id)
                                                    }
                                                    onMouseOut={() => setIsHoveredPayment('')}
                                                  />
                                                </Badge>
                                                {isHoveredPayment === seatEntries?.bookings?.paid?.details[0]?.id && (
                                                  <div className="hover-info">
                                                    {seatEntries?.bookings?.paid?.details &&
                                                      seatEntries?.bookings?.paid?.details?.map(
                                                        (booking: any, index: number) => (
                                                          <Flex gap={16} align="center" key={`booking-${index}`}>
                                                            <Flex align="start" justify="center" className="flex-col">
                                                              <p className="fs-16 fw-500 text-blue">
                                                                {booking?.ticket_code}
                                                              </p>
                                                              <p className="fs-14 fw-500">
                                                                <img
                                                                  src={imageStatusTicket(booking, true, false, false)}
                                                                  alt=""
                                                                />
                                                              </p>
                                                            </Flex>
                                                            <div className="max-content">
                                                              <p className="fs-16 fw-500 text-blue">
                                                                {booking?.customer_name}
                                                              </p>
                                                              <p className="fs-14 fw-500 text-light-blue">{`${booking?.start_location} - ${booking?.end_location}`}</p>
                                                            </div>
                                                          </Flex>
                                                        ),
                                                      )}
                                                  </div>
                                                )}
                                              </div>
                                            ) : (
                                              <></>
                                            )}
                                          </Space>

                                          <Space size="middle">
                                            {seatEntries?.bookings?.open_api &&
                                            seatEntries?.bookings?.open_api?.details?.length ? (
                                              <div className="relative block-info-booking">
                                                <Badge count={seatEntries?.bookings?.open_api?.details?.length}>
                                                  <img
                                                    src={IconOpenApi}
                                                    alt=""
                                                    onMouseOver={() =>
                                                      setIsHoveredOpenApi(
                                                        seatEntries?.bookings?.open_api?.details[0]?.id,
                                                      )
                                                    }
                                                    onMouseOut={() => setIsHoveredOpenApi('')}
                                                  />
                                                </Badge>
                                                {isHoveredOpenApi ===
                                                  seatEntries?.bookings?.open_api?.details[0]?.id && (
                                                  <div className="hover-info">
                                                    {seatEntries?.bookings?.open_api?.details &&
                                                      seatEntries?.bookings?.open_api?.details?.map(
                                                        (booking: any, index: number) => (
                                                          <Flex gap={16} align="center" key={`booking-${index}`}>
                                                            <div>
                                                              <p className="fs-16 fw-500 text-blue"></p>
                                                              <p className="text-reserve fs-14 fw-500">
                                                                <img
                                                                  src={imageStatusTicket(booking, false, false, true)}
                                                                  alt=""
                                                                />
                                                              </p>
                                                            </div>
                                                            <div className="max-content">
                                                              <p className="fs-16 fw-500 text-blue">
                                                                {booking?.customer_name}
                                                              </p>
                                                              <p className="fs-14 fw-500 text-light-blue">{`${booking?.start_location} - ${booking?.end_location}`}</p>
                                                            </div>
                                                          </Flex>
                                                        ),
                                                      )}
                                                  </div>
                                                )}
                                              </div>
                                            ) : (
                                              <></>
                                            )}
                                          </Space>
                                        </Flex>
                                      ) : (
                                        <></>
                                      )}
                                      {seatFloors?.type < Constant.NORMAL_SEAT && (
                                        <Typography className="fw-600 mt-1">
                                          {seatCustomerEntries?.customer_name}
                                        </Typography>
                                      )}
                                    </div>
                                    {seatEntries?.new_booking?.customer && isShowNewBooking ? (
                                      <div className="mt-3 customer-info-ticket">
                                        {listBooking?.count_segment !== 1 ? (
                                          <p className="fs-16 fw-600 text-blue">{`${
                                            seatEntries?.new_booking?.customer
                                          } (${
                                            seatEntries?.bookings?.open_api?.details?.length
                                              ? 'N/A'
                                              : seatEntries?.new_booking?.phone
                                          })`}</p>
                                        ) : (
                                          <div>
                                            <p className="fs-16 fw-600 text-blue">{`${seatEntries?.new_booking?.customer}`}</p>
                                            <Flex align="center" gap={8} className="mt-1">
                                              <p className="fs-16 fw-500 text-blue">
                                                {seatEntries?.bookings?.open_api?.details?.length
                                                  ? 'N/A'
                                                  : seatEntries?.new_booking?.phone}
                                              </p>
                                              {seatEntries?.total_paid ||
                                              seatEntries?.bookings?.paid?.details?.length ? (
                                                <img
                                                  src={
                                                    seatEntries?.new_booking?.payer?.company?.id
                                                      ? iconCarGroup
                                                      : iconAgent
                                                  }
                                                  alt=""
                                                />
                                              ) : seatEntries?.bookings?.open_api?.details?.length ? (
                                                <img src={iconOpenApi} alt="" />
                                              ) : seatEntries?.new_booking?.orderer?.company?.id ? (
                                                <img src={iconCompanyReserve} alt="" />
                                              ) : (
                                                <img src={iconAgentReserve} alt="" />
                                              )}
                                            </Flex>
                                          </div>
                                        )}
                                        {listBooking?.count_segment !== 1 ? (
                                          <Flex gap={8} align="center" className="mt-1">
                                            <img src={iconNew} alt="" />
                                            <p className="fs-14 fw-500 text-blue">{`${seatEntries?.new_booking?.start_location} - ${seatEntries?.new_booking?.end_location}`}</p>
                                          </Flex>
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    {listBooking?.count_segment === 1 && seatEntries ? (
                                      <div className="address-bus fw-500 fs-14 mt-2">
                                        <Typography className="fs-14">
                                          {seatEntries?.new_booking?.pickup_location?.location_name
                                            ? `${
                                                seatEntries?.new_booking?.pickup_location?.location_name
                                              } (${seatEntries?.new_booking?.pickup_location?.time?.slice(0, 5)}${
                                                (seatEntries?.new_booking?.pickup_location?.diff_day ||
                                                  seatEntries?.new_booking?.drop_off_location?.diff_day) > 0
                                                  ? ` - ${dayjs(listBooking?.travel_info?.depart_date)
                                                      ?.add(seatEntries?.new_booking?.pickup_location?.diff_day, 'day')
                                                      ?.format(DateFormat)}`
                                                  : ''
                                              })`
                                            : listBooking?.schedule?.depart_date === listBooking?.schedule?.arrive_date
                                            ? `${
                                                seatEntries?.new_booking?.pickup_extra
                                              } (${listBooking?.schedule?.depart_time?.slice(0, 5)})`
                                            : `${
                                                seatEntries?.new_booking?.pickup_extra
                                              } (${listBooking?.schedule?.depart_time?.slice(0, 5)} - ${
                                                listBooking?.schedule?.depart_date
                                              })`}
                                        </Typography>
                                        <Typography className="fs-14">
                                          {seatEntries?.new_booking?.drop_off_location?.location_name
                                            ? `${
                                                seatEntries?.new_booking?.drop_off_location?.location_name
                                              } (${seatEntries?.new_booking?.drop_off_location?.time?.slice(0, 5)}${
                                                (seatEntries?.new_booking?.pickup_location?.diff_day ||
                                                  seatEntries?.new_booking?.drop_off_location?.diff_day) > 0
                                                  ? ` - ${dayjs(listBooking?.travel_info?.depart_date)
                                                      ?.add(
                                                        seatEntries?.new_booking?.drop_off_location?.diff_day,
                                                        'day',
                                                      )
                                                      ?.format(DateFormat)}`
                                                  : ''
                                              })`
                                            : listBooking?.schedule?.depart_date === listBooking?.schedule?.arrive_date
                                            ? `${
                                                seatEntries?.new_booking?.drop_off_extra
                                              } (${listBooking?.schedule?.arrive_time?.slice(0, 5)})`
                                            : `${
                                                seatEntries?.new_booking?.drop_off_extra
                                              } (${listBooking?.schedule?.arrive_time?.slice(0, 5)} - ${
                                                listBooking?.schedule?.arrive_date
                                              })`}
                                        </Typography>
                                      </div>
                                    ) : (
                                      ''
                                    )}

                                    {listBooking?.count_segment === 1 && seatEntries?.new_booking?.note ? (
                                      <div className="note fw-500 fs-14 mt-2">
                                        <Typography className="fs-14">
                                          {`*${seatEntries?.new_booking?.note}`}
                                        </Typography>
                                      </div>
                                    ) : (
                                      ''
                                    )}

                                    <div className={`${seatEntries?.customer?.name ? '' : 'price-item'} mb-18 mt-3`}>
                                      {seatEntries && !listBookingRender?.contract?.id ? (
                                        <>
                                          {(listBooking?.count_segment === 1 && seatEntries?.total_paid) ||
                                          listBooking?.count_segment !== 1 ? (
                                            <div className="d-flex gap-x-2 items-center">
                                              <img src={iconPaid} alt="" />
                                              <p className="text-blue fs-14 fw-600">
                                                {` ${
                                                  seatEntries && seatEntries?.total_paid
                                                    ? formattedPrice(seatEntries?.total_paid)
                                                    : 0
                                                } VND`}
                                              </p>
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                          {(listBooking?.count_segment === 1 && seatEntries?.total_reserve) ||
                                          listBooking?.count_segment !== 1 ? (
                                            <div className="d-flex gap-x-2 items-center mt-1">
                                              <img src={iconUnPaid} alt="" />
                                              <p className="text-blue fs-14 fw-500">
                                                {` ${
                                                  seatEntries && seatEntries?.total_reserve
                                                    ? formattedPrice(seatEntries?.total_reserve)
                                                    : 0
                                                } VND`}
                                              </p>
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </>
                                )}

                                <div className="btn-diagram-block">
                                  {seatEntries?.status === 'locked' || (isLocked && !seatEntries) ? (
                                    ''
                                  ) : seatFloors?.type > Constant.EXTRA_DRIVER_SEAT ? (
                                    <>
                                      <>
                                        {seatEntries &&
                                        selectedSeatNames?.length >1  &&
                                        selectedSeatNames?.includes(seatFloors?.name) &&
                                        !isWaitingCustomerList ? (
                                          <Button
                                            className="btn-diagram"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleChangeBooking(selectedSeatNames);
                                            }}
                                          >
                                            <Tooltip title={'Chuyển vé'} key={'edt2'} placement="right">
                                              <img src={IcMoveTicket} alt="" />
                                            </Tooltip>
                                          </Button>
                                        ) : (
                                          ''
                                        )}
                                      </>

                                      {seatEntries && !seatEntries?.is_lock && selectedSeatNames?.length < 2 ? (
                                        <>
                                          {((listBooking?.trip?.status !== 'departed' &&
                                            listBooking?.trip?.status !== 'canceled') ||
                                            !isBooking) &&
                                          (selectedSeatNames?.length > 1 ? seatEntries?.is_available : true) &&
                                          (group !== USER_GROUP.AGENT ||
                                            (group === USER_GROUP.AGENT &&
                                              searchDateBooking &&
                                              listBooking?.booked_seat?.includes(seatFloors?.name) &&
                                              !isLocked)) &&
                                          listBooking?.count_segment !== 1 ? (
                                            <Button
                                              className={`btn-diagram ${
                                                (seatEntries && !seatEntries?.is_available) || isWaitingCustomerList
                                                  ? 'disable'
                                                  : ''
                                              }`}
                                              disabled={
                                                (seatEntries && !seatEntries?.is_available) ||
                                                isWaitingCustomerList ||
                                                (listAssistBooking?.length &&
                                                  listFreeSeat?.length &&
                                                  !listFreeSeat?.includes(seatFloors?.name))
                                              }
                                              onClick={() => handleCreateBooking(seatFloors?.name, rowIndex, colIndex)}
                                            >
                                              <Tooltip title={'Đặt vé'} key={'bkt'} placement="right">
                                                <img
                                                  src={
                                                    (seatEntries && !seatEntries?.is_available) || isWaitingCustomerList
                                                      ? IconBan
                                                      : iconBooking
                                                  }
                                                  alt=""
                                                />
                                              </Tooltip>
                                            </Button>
                                          ) : (
                                            ''
                                          )}
                                          {listBooking?.contract?.code ? (
                                            ''
                                          ) : listBooking?.count_segment === 1 ? (
                                            <>
                                              <Button
                                                className="btn-diagram"
                                                onClick={() =>
                                                  handleEditBooking(
                                                    'Chỉnh sửa',
                                                    getInfoSingleDetail(seatEntries)?.ticket_code,
                                                    getInfoSingleDetail(seatEntries)?.id,
                                                    getInfoSingleDetail(seatEntries),
                                                    seatFloors?.name
                                                  )
                                                }
                                              >
                                                <Tooltip title="Chỉnh sửa" placement="top">
                                                  <img src={IcEditTicket} alt={''} />
                                                </Tooltip>
                                              </Button>
                                              <Button
                                                className="btn-diagram"
                                                onClick={() =>
                                                  handleEditBooking(
                                                    'Chuyển vé',
                                                    getInfoSingleDetail(seatEntries)?.ticket_code,
                                                    getInfoSingleDetail(seatEntries)?.id,
                                                    getInfoSingleDetail(seatEntries),
                                                    seatFloors?.name,
                                                  )
                                                }
                                              >
                                                <Tooltip title={'Chuyển vé'} placement="top">
                                                  <img src={IcMoveTicket} alt="" />
                                                </Tooltip>
                                              </Button>
                                              <Button
                                                className="btn-diagram"
                                                onClick={() =>
                                                  handleEditBooking(
                                                    'In vé',
                                                    getInfoSingleDetail(seatEntries)?.ticket_code,
                                                    getInfoSingleDetail(seatEntries)?.id,
                                                    getInfoSingleDetail(seatEntries),
                                                    seatFloors?.name

                                                  )
                                                }
                                              >
                                                <Tooltip title={'In vé'} placement="top">
                                                  <img src={IcPrintTicket} alt={''} />
                                                </Tooltip>
                                              </Button>
                                              <Button
                                                className="btn-diagram"
                                                onClick={() =>
                                                  handleEditBooking(
                                                    'Gửi mail',
                                                    getInfoSingleDetail(seatEntries)?.ticket_code,
                                                    getInfoSingleDetail(seatEntries)?.id,
                                                    getInfoSingleDetail(seatEntries),
                                                    seatFloors?.name

                                                  )
                                                }
                                              >
                                                <Tooltip title={'Gửi mail'} placement="top">
                                                  <img src={IcSendMail} alt={''} />
                                                </Tooltip>
                                              </Button>
                                            </>
                                          ) : (
                                            <Button
                                              className="btn-diagram"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                getDetailBooking(seatFloors?.name);
                                              }}
                                            >
                                              <Tooltip title={'Chỉnh sửa'} key={'edt2'} placement="right">
                                                <img src={IcEdit} alt="" />
                                              </Tooltip>
                                            </Button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {seatEntries?.new_booking && isWaitingCustomerList ? (
                                            <Button
                                              className="btn-diagram"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                getDetailBooking(seatFloors?.name);
                                              }}
                                            >
                                              <Tooltip title={'Chỉnh sửa'} key={'edt2'} placement="right">
                                                <img src={IcEdit} alt="" />
                                              </Tooltip>
                                            </Button>
                                          ) : (
                                            ''
                                          )}
                                          {selectedSeatNames?.length > 1 &&
                                          // listAvailableSeat
                                          selectedSeatNames.find((selected: any) => selected === seatFloors?.name) &&
                                          (listBooking?.trip?.status !== 'departed' || !isBooking) &&
                                          // !seatEntries &&
                                          ((!isOpenBus && listBooking?.trip?.status !== 'canceled') || isOpenBus) &&
                                          !(
                                            dateSelect > dayjs(listBooking?.schedule?.open_before_day) ||
                                            listBooking?.schedule?.open_before === 0
                                          ) &&
                                          (group !== USER_GROUP.AGENT ||
                                            (group === USER_GROUP.AGENT &&
                                              searchDateBooking &&
                                              !listBooking?.booked_seat?.includes(seatFloors?.name))) ? (
                                            <>
                                              {checkAvailableSeat ? (
                                                <Button
                                                  className={`btn-diagram ${
                                                    (seatEntries && !seatEntries?.is_available) || isWaitingCustomerList
                                                      ? 'disable'
                                                      : ''
                                                  }`}
                                                  disabled={
                                                    (seatEntries && !seatEntries?.is_available) ||
                                                    isWaitingCustomerList ||
                                                    (listAssistBooking?.length &&
                                                      listFreeSeat?.length &&
                                                      !listFreeSeat?.includes(seatFloors?.name))
                                                  }
                                                  onClick={() =>
                                                    handleCreateMultiBooking(selectedSeatNames, rowIndex, colIndex)
                                                  }
                                                >
                                                  <Tooltip title={'Đặt vé'} key={'bkt'} placement="right">
                                                    <img
                                                      src={
                                                        (seatEntries && !seatEntries?.is_available) ||
                                                        isWaitingCustomerList
                                                          ? IconBan
                                                          : iconBooking
                                                      }
                                                      alt=""
                                                    />
                                                  </Tooltip>
                                                </Button>
                                              ) : (
                                                ''
                                              )}
                                              {group !== USER_GROUP.AGENT && !isWaitingCustomerList && (
                                                <Button
                                                  className="btn-diagram"
                                                  disabled={seatEntries?.status === 'hold'}
                                                  onClick={() => handleLockMultiBooking(selectedSeatNames)}
                                                >
                                                  <Tooltip title={'Khóa ghế'} key={'bkt-mt'} placement="right">
                                                    <img src={IcLock} alt="" />
                                                  </Tooltip>
                                                </Button>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {(listBooking?.trip?.status !== 'departed' || !isBooking) &&
                                                ((!isOpenBus && listBooking?.trip?.status !== 'canceled') ||
                                                  isOpenBus) &&
                                                !seatEntries?.is_lock &&
                                                !(listBooking?.schedule?.open_before_day
                                                  ? dateSelect > dayjs(listBooking?.schedule?.open_before_day) ||
                                                    listBooking?.schedule?.open_before === 0
                                                  : false) &&
                                                (group !== USER_GROUP.AGENT ||
                                                  (group === USER_GROUP.AGENT &&
                                                    (searchDateBooking &&
                                                    listBooking?.schedule?.agent_seats_custom &&
                                                    listBooking?.schedule?.agent_seats_custom[searchDateBooking]
                                                      ? listBooking?.schedule?.agent_seats_custom[
                                                          searchDateBooking
                                                        ]?.includes(seatFloors?.name) &&
                                                        !listBooking?.booked_seat?.includes(seatFloors?.name)
                                                      : listBooking?.schedule?.agent_seats?.includes(
                                                          seatFloors?.name,
                                                        )) &&
                                                    !listBooking?.booked_seat?.includes(seatFloors?.name))) && (
                                                  <Button
                                                    className={`btn-diagram ${
                                                      (seatEntries && !seatEntries?.is_available) ||
                                                      isWaitingCustomerList
                                                        ? 'disable'
                                                        : ''
                                                    }`}
                                                    disabled={
                                                      (seatEntries && !seatEntries?.is_available) ||
                                                      isWaitingCustomerList ||
                                                      (listAssistBooking?.length &&
                                                        listFreeSeat?.length &&
                                                        !listFreeSeat?.includes(seatFloors?.name))
                                                    }
                                                    onClick={() => {
                                                      if (
                                                        seatFloors.type > Constant.EXTRA_DRIVER_SEAT &&
                                                        seatFloors.name
                                                      ) {
                                                        if (!busTypeData?.[`floor1`][rowIndex][colIndex]?.selected) {
                                                          handleChangeTicket(rowIndex, colIndex, 1);
                                                        }

                                                        handleCreateBooking(seatFloors.name, rowIndex, colIndex);
                                                      }
                                                    }}
                                                  >
                                                    <Tooltip title={'Đặt vé'} key={'bkt2'} placement="right">
                                                      <img
                                                        src={
                                                          (seatEntries && !seatEntries?.is_available) ||
                                                          isWaitingCustomerList
                                                            ? IconBan
                                                            : iconBooking
                                                        }
                                                        alt=""
                                                      />
                                                    </Tooltip>
                                                  </Button>
                                                )}
                                              {group !== USER_GROUP.AGENT &&
                                                !seatEntries?.is_lock &&
                                                !isWaitingCustomerList &&
                                                !seatEntries &&
                                                (listBooking?.trip?.status !== 'departed' || !isBooking) &&
                                                ((!isOpenBus && listBooking?.trip?.status !== 'canceled') ||
                                                  isOpenBus) &&
                                                !(
                                                  dateSelect > dayjs(listBooking?.schedule?.open_before_day) ||
                                                  listBooking?.schedule?.open_before === 0
                                                ) && (
                                                  <Button
                                                    className="btn-diagram"
                                                    disabled={seatEntries?.status === 'hold'}
                                                    onClick={() => {
                                                      if (
                                                        seatFloors.type > Constant.EXTRA_DRIVER_SEAT &&
                                                        seatFloors.name
                                                      ) {
                                                        if (!busTypeData?.[`floor1`][rowIndex][colIndex]?.selected) {
                                                          handleChangeTicket(rowIndex, colIndex, 1);
                                                        }
                                                        handleLockBooking(seatFloors.name);
                                                      }
                                                    }}
                                                  >
                                                    <Tooltip title={'Khóa ghế'} key={'lock3'} placement="right">
                                                      <img src={IcLock} alt="" />
                                                    </Tooltip>
                                                  </Button>
                                                )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  ) : seatFloors.type === Constant.DRIVER_SEAT ||
                                    seatFloors.type === Constant.EXTRA_DRIVER_SEAT ? (
                                    ''
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                {listBooking?.count_segment === 1 &&
                                listBooking?.price_schedule?.reason &&
                                seatFloors?.type > Constant.EXTRA_DRIVER_SEAT ? (
                                  <div className="price-schedule-block">
                                    {seatEntries?.new_booking?.price_schedule?.price ||
                                    seatEntries?.new_booking?.price_schedule?.percent ? (
                                      <p className="text-blue fs-13 fw-500">
                                        {getPriceScheduleReason(seatEntries?.new_booking?.price_schedule, false)}
                                      </p>
                                    ) : (
                                      <p className="text-blue fs-13 fw-500">
                                        {getPriceScheduleReason(listBooking?.price_schedule, false)}
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            }
                          />
                        </Col>
                      )
                    );
                  })}
                </Row>
              );
            })}
          </div>
        ) : (
          ''
        )}
        {(statusFloor === 2 || isShowAllFloor) && listBooking?.schedule?.bus_type?.seat_map?.count_floor !== 1 ? (
          <div className={`${statusFloor === 2 && !isShowAllFloor ? 'w-100' : 'w-50'}`}>
            <Typography className="title-box-floor2">Tầng 2</Typography>
            {listBooking?.schedule?.bus_type?.seat_map[`floor2`]?.map((rowSeats: any, rowIndex: number) => {
              const nonEmptySeatsCount = rowSeats.filter((seat: any) => seat.name || seat.type !== 0).length;
              const isSingleSeatRow = nonEmptySeatsCount === 1;
              const firstRow = rowIndex === 0 && rowSeats;
              const isSingleSeat =
                firstRow?.length &&
                firstRow?.filter((item: any) => item?.name && item?.type <= Constant.EXTRA_DRIVER_SEAT)?.length === 1;
              return (
                <Row
                  gutter={[12, 12]}
                  key={rowIndex}
                  className="mt-2"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${nonEmptySeatsCount}, 1fr)`,
                  }}
                >
                  {rowSeats?.map((seatFloors: any, colIndex: number) => {
                    const seatEntries =
                      isWaitingCustomerList &&
                      !!listCustomerBooking?.bookings?.data &&
                      listCustomerBooking?.bookings?.data[seatFloors?.name]
                        ? listCustomerBooking?.bookings?.data[seatFloors?.name]
                        : listBookingRender?.booking?.data && listBookingRender?.booking?.data[seatFloors?.name]
                        ? listBookingRender?.booking?.data[seatFloors?.name]
                        : undefined;
                    const seatCustomerEntries = listBooking?.customers?.data?.find(
                      (entry: any) => entry.seat_number === seatFloors.name,
                    );

                    const selectedSeatNames = isShowAllFloor
                      ? ['floor1', 'floor2'].flatMap((floor) =>
                          busTypeData?.[floor]?.flatMap(
                            (row: any) =>
                              !date.isAfter(listBooking?.travel_info?.depart_time, 'day') &&
                              row.filter((seat: any) => seat.selected).map((seat: any) => seat.name),
                          ),
                        )
                      : busTypeData?.[`floor2`].flatMap(
                          (row: any) =>
                            !date.isAfter(listBooking?.travel_info?.depart_time, 'day') &&
                            row.filter((seat: any) => seat.selected).map((seat: any) => seat.name),
                        );
                    const isLocked =
                      listBookingRender?.locked_booking?.length &&
                      listBookingRender?.locked_booking?.find((booking: any) => booking === seatFloors?.name);

                    const checkAvailableSeat = (() => {
                      const seatsData = listBookingRender?.booking?.data;
                      if (!seatsData || !Array.isArray(selectedSeatNames) || selectedSeatNames.length < 1) {
                        return undefined;
                      }
                      const validSeats = selectedSeatNames.filter((seatName) => seatName in seatsData);

                      if (validSeats.length === 0) {
                        return true;
                      }
                      return validSeats.every((seatName) => seatsData[seatName]?.is_available === true);
                    })();
                    return (
                      (seatFloors.name || seatFloors.type !== Constant.DEFAULT_SEAT) && (
                        <Col
                          key={colIndex}
                          onClick={() =>
                            seatFloors.type > Constant.EXTRA_DRIVER_SEAT &&
                            seatFloors.name &&
                            (seatEntries || !seatEntries) &&
                            !isLocked &&
                            !isWaitingCustomerList &&
                            !seatEntries?.is_lock &&
                            !(isMoveTicketWaiting && dataMoveTicket?.ticket_code) &&
                            (group !== USER_GROUP.AGENT ||
                              (group === USER_GROUP.AGENT &&
                                searchDateBooking &&
                                (seatEntries || !seatEntries) &&
                                listBooking?.schedule?.agent_seats?.includes(seatFloors?.name))) &&
                            handleChangeTicket(rowIndex, colIndex, 2)
                          }
                          ref={(el) => {
                            refs.current[seatEntries?.new_booking?.ticket_code] = el;
                          }}
                        >
                          <Checkbox className="checkbox-diagram d-none" checked={seatFloors.selected} />
                          <Card
                            onClick={() =>
                              isMoveTicketWaiting &&
                              listAvailableSeat?.available_seats?.length &&
                              dataMoveTicket?.ticket_code &&
                              seatFloors?.type > 2 &&
                              (listAssistBooking?.length && listFreeSeat?.length
                                ? listFreeSeat?.includes(seatFloors?.name)
                                : true) &&
                              (group !== USER_GROUP.AGENT ||
                                (group === USER_GROUP.AGENT &&
                                  (searchDateBooking &&
                                  listBooking?.schedule?.agent_seats_custom &&
                                  listBooking?.schedule?.agent_seats_custom[searchDateBooking]
                                    ? listBooking?.schedule?.agent_seats_custom[searchDateBooking]?.includes(
                                        seatFloors?.name,
                                      ) && !listBooking?.booked_seat?.includes(seatFloors?.name)
                                    : listBooking?.schedule?.agent_seats?.includes(seatFloors?.name) &&
                                      !listBooking?.booked_seat?.includes(seatFloors?.name)))) &&
                              handleMoveTicket(seatFloors?.name)
                            }
                            className={`mt-1 ant-card-diagram diagram
                          ${isSingleSeat ? 'w-60' : isSingleSeatRow && 'w-30'}
                         ${seatEntries ? 'booked' : ''}
                           ${
                             listBooking?.count_segment === 1 && seatEntries?.bookings?.open_api?.details?.length
                               ? 'open_api'
                               : ''
                           }
                                 ${
                                   isMoveTicketWaiting && listAvailableSeat?.available_seats?.length
                                     ? !listAvailableSeat?.available_seats?.includes(seatFloors?.name)
                                       ? 'cursor-move ban'
                                       : 'cursor-move'
                                     : ''
                                 }
                                        ${
                                          listAssistBooking?.length &&
                                          listFreeSeat?.length &&
                                          !listFreeSeat?.includes(seatFloors?.name)
                                            ? 'cursor-move ban'
                                            : ''
                                        }
                         ${
                           seatFloors?.type === Constant.DRIVER_SEAT || seatFloors?.type === Constant.EXTRA_DRIVER_SEAT
                             ? 'driver'
                             : ''
                         }
                         ${
                           (isLocked ||
                             (group === USER_GROUP.AGENT &&
                               searchDateBooking &&
                               !listBooking?.schedule?.agent_seats?.includes(seatFloors?.name))) &&
                           !seatEntries
                             ? 'driver ban'
                             : ''
                         }
                             ${seatEntries?.is_lock ? 'locked' : ''}
                              ${
                                busTypeData &&
                                busTypeData?.[`floor2`] &&
                                busTypeData?.[`floor2`][rowIndex] &&
                                busTypeData?.[`floor2`][rowIndex][colIndex] &&
                                busTypeData?.[`floor2`][rowIndex][colIndex]?.name === seatFloors?.name &&
                                busTypeData?.[`floor2`][rowIndex][colIndex]?.selected &&
                                seatFloors.type > Constant.EXTRA_DRIVER_SEAT &&
                                !seatEntries?.is_lock &&
                                (listAssistBooking?.length && listFreeSeat?.length
                                  ? listFreeSeat?.includes(seatFloors?.name)
                                  : true) &&
                                // !seatEntries &&
                                !isLocked &&
                                (group !== USER_GROUP.AGENT ||
                                  (group === USER_GROUP.AGENT &&
                                    searchDateBooking &&
                                    // !seatEntries &&
                                    listBooking?.schedule?.agent_seats?.includes(seatFloors?.name))) &&
                                (listBooking?.trip?.status !== 'departed' || !isBooking) &&
                                ((!isOpenBus && listBooking?.trip?.status !== 'canceled') || isOpenBus) &&
                                !(
                                  dateSelect > dayjs(listBooking?.schedule?.open_before_day) ||
                                  listBooking?.schedule?.open_before === 0
                                ) &&
                                !(isMoveTicket && dataMoveTicket?.ticket_code)
                                  ? 'selected'
                                  : ''
                              }
                       ${
                         (seatFloors.type === Constant.DRIVER_SEAT ||
                           seatFloors.type === Constant.EXTRA_DRIVER_SEAT ||
                           seatEntries?.status === 'locked' ||
                           (isWaitingCustomerList &&
                             !(isMoveTicketWaiting && listAvailableSeat?.available_seats?.length)) ||
                           (group === USER_GROUP.AGENT &&
                             searchDateBooking &&
                             !listBooking?.schedule?.agent_seats?.includes(seatFloors?.name) &&
                             ((!isOpenBus && listBooking?.trip?.status !== 'canceled') || isOpenBus) &&
                             listBooking?.trip?.status !== 'canceled' &&
                             !(
                               dateSelect > dayjs(listBooking?.schedule?.open_before_day) ||
                               listBooking?.schedule?.open_before === 0
                             ))) &&
                         !seatEntries
                           ? 'ban'
                           : ''
                       }
                          `}
                            style={getSeatStyle(seatFloors, seatEntries)}
                            cover={
                              <div
                                className={`bus-diagram-card ${seatFloors?.type < Constant.NORMAL_SEAT ? 'driver' : ''}
                                  ${seatEntries?.total_paid ? 'booked' : ''}
                                  `}
                              >
                                {seatEntries?.is_lock ? (
                                  <>
                                    <div className="header-card-diagram locked">
                                      <Typography className="fw-600 title-card">
                                        <Image
                                          src={
                                            typeSeatItems?.find((item: any) => +item?.id === +seatFloors.type)?.image
                                          }
                                          alt=""
                                          height={32}
                                          preview={false}
                                          className={`img-type-seat`}
                                        />
                                        <span className="seat-name-booking d-flex items-center mb-0">
                                          {seatFloors.name}
                                        </span>
                                      </Typography>
                                    </div>
                                    <div className="block-content">
                                      <Button
                                        className="btn btn-block"
                                        onClick={() => handleUnLockBooking(seatFloors?.name)}
                                      >
                                        <img src={IcLock} alt="" />
                                      </Button>
                                      <Typography className="fw-500 fs-16 mt-2">Ghế này đã bị khoá!</Typography>
                                      <Typography className="fs-12 fw-400">{`Bởi ${seatEntries?.staff_lock}`}</Typography>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="header-card-diagram">
                                      <Typography
                                        className={`fw-600 ${
                                          seatEntries?.orderer?.name ? 'is-booking' : ''
                                        } title-card  items-center space-between w-100`}
                                      >
                                        <Flex align="center" justify="center" gap={10}>
                                          <div
                                            className="title-seat-diagram"
                                            style={
                                              seatFloors?.type === Constant.DRIVER_SEAT ||
                                              seatFloors?.type === Constant.EXTRA_DRIVER_SEAT
                                                ? {
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                  }
                                                : {}
                                            }
                                          >
                                            <Image
                                              src={
                                                typeSeatItems?.find((item: any) => +item?.id === +seatFloors.type)
                                                  ?.image
                                              }
                                              alt=""
                                              height={32}
                                              preview={false}
                                              className={`img-type-seat w-fit`}
                                            />
                                            <p
                                              className={`seat-name-booking ${
                                                seatFloors.type > Constant.EXTRA_DRIVER_SEAT ? 'ticket' : ''
                                              } `}
                                              style={
                                                seatFloors.type === Constant.EXTRA_DRIVER_SEAT ||
                                                seatFloors.type === Constant.DRIVER_SEAT
                                                  ? { marginBottom: 0 }
                                                  : {}
                                              }
                                            >
                                              {seatFloors.type > Constant.EXTRA_DRIVER_SEAT ? '' : seatFloors.name}
                                            </p>
                                          </div>
                                          {!listBooking?.contract?.code ? (
                                            <>
                                              {seatFloors?.type > Constant.EXTRA_DRIVER_SEAT && (
                                                <>
                                                  <>
                                                    {listBooking?.count_segment === 1 ? (
                                                      <span className="seat-name-booking">
                                                        {` ${
                                                          seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                                          seatEntries?.new_booking?.ticket_code
                                                            ? seatEntries?.new_booking?.ticket_code
                                                            : seatFloors?.name
                                                        }  - ${
                                                          seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                                          seatEntries?.new_booking?.ticket_code
                                                            ? seatFloors?.name
                                                            : seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                                              typeSeatItems?.find(
                                                                (item: any) => +item?.id === +seatFloors.type,
                                                              )?.name
                                                        }`}
                                                      </span>
                                                    ) : (
                                                      <span className="seat-name-booking">
                                                        {`${
                                                          seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                                          typeSeatItems?.find(
                                                            (item: any) => +item?.id === +seatFloors.type,
                                                          )?.name
                                                        } -  ${
                                                          seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                                          !seatEntries?.ticket_code
                                                            ? seatFloors?.name
                                                            : ''
                                                        }`}
                                                      </span>
                                                    )}
                                                  </>
                                                </>
                                              )}
                                              {!(
                                                (seatEntries?.status === 'hold' || seatEntries?.status === 'reserve') &&
                                                (seatEntries?.source === 'openapi' || seatEntries?.source === 'company')
                                              ) ? (
                                                <span className="seat-name-booking ticket-code">
                                                  {seatEntries?.ticket_code
                                                    ? `${seatEntries?.ticket_code} - ${seatFloors?.name}`
                                                    : seatEntries?.ticket_code}
                                                </span>
                                              ) : (
                                                <span className="seat-name-booking ticket-code">
                                                  {seatFloors?.name}
                                                </span>
                                              )}
                                            </>
                                          ) : seatFloors?.type > Constant.EXTRA_DRIVER_SEAT ? (
                                            <p className={`seat-name-booking`}>{seatFloors?.name}</p>
                                          ) : (
                                            ''
                                          )}
                                          {listBooking?.count_segment === 1 && seatEntries?.new_booking?.expired_at ? (
                                            <div
                                              className="countdown-diagram"
                                              style={{
                                                position: 'absolute',
                                                top: '13px',
                                                right: '5px',
                                              }}
                                            >
                                              <CountdownComponent seatEntriesExpired={seatEntries?.new_booking} />
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                        </Flex>
                                        {seatEntries &&
                                        !seatEntries?.is_available &&
                                        listBooking?.count_segment !== 1 ? (
                                          <img src={icSold} alt="" />
                                        ) : (
                                          <></>
                                        )}
                                      </Typography>
                                    </div>

                                    <div className="block-info relative">
                                      <Typography className="fw-500 fs-14 mr-5 orderer-name">
                                        {seatEntries?.orderer?.name}
                                      </Typography>
                                      {seatFloors?.type === Constant.DRIVER_SEAT && (
                                        <>
                                          {listBooking?.trip?.drivers?.map((driver: any, index: number) => (
                                            <Typography className="fw-500 fs-16" key={index}>
                                              <span className="fw-600">{driver.name}</span> <br />
                                              <span> {driver.phone}</span>
                                            </Typography>
                                          ))}
                                        </>
                                      )}
                                      {seatFloors?.type === Constant.EXTRA_DRIVER_SEAT && (
                                        <>
                                          {listBooking?.trip?.extra_drivers?.map((driver: any, index: number) => (
                                            <Typography key={index} className="fw-500 fs-16">
                                              <span className="fw-600">{driver.name}</span> <br />
                                              <span>{driver.phone}</span>
                                            </Typography>
                                          ))}
                                        </>
                                      )}
                                      {seatFloors?.type > Constant.EXTRA_DRIVER_SEAT &&
                                      seatEntries &&
                                      listBooking?.count_segment !== 1 ? (
                                        <Flex gap={20} className="mt-4 status-booking-block">
                                          <Space size="middle" className="relative block-info-booking">
                                            {seatEntries?.bookings?.reserve &&
                                            seatEntries?.bookings?.reserve?.details?.length ? (
                                              <div key={seatEntries?.ticket_code}>
                                                <Badge count={seatEntries?.bookings?.reserve?.details?.length}>
                                                  <img
                                                    src={IconReserve}
                                                    alt=""
                                                    onMouseOver={() =>
                                                      setIsHoveredReserve(
                                                        seatEntries?.bookings?.reserve?.details[0]?.id,
                                                      )
                                                    }
                                                    onMouseOut={() => setIsHoveredReserve('')}
                                                  />
                                                </Badge>
                                                {isHoveredReserve ===
                                                  seatEntries?.bookings?.reserve?.details[0]?.id && (
                                                  <div className="hover-info">
                                                    {seatEntries?.bookings?.reserve?.details &&
                                                      seatEntries?.bookings?.reserve?.details?.map(
                                                        (booking: any, index: number) => (
                                                          <Flex gap={16} align="center" key={`booking-${index}`}>
                                                            <div>
                                                              <p className="fs-16 fw-500 text-blue">
                                                                {booking?.ticket_code}
                                                              </p>
                                                              <img
                                                                src={imageStatusTicket(booking, false, true, false)}
                                                                alt=""
                                                              />
                                                              {/* <p className="text-reserve fs-14 fw-500"></p> */}
                                                            </div>
                                                            <div className="max-content">
                                                              <p className="fs-16 fw-500 text-blue">
                                                                {booking?.customer_name}
                                                              </p>
                                                              <p className="fs-14 fw-500 text-light-blue">{`${booking?.start_location} - ${booking?.end_location}`}</p>
                                                            </div>
                                                          </Flex>
                                                        ),
                                                      )}
                                                  </div>
                                                )}
                                              </div>
                                            ) : (
                                              <></>
                                            )}
                                          </Space>
                                          <Space size="middle">
                                            {seatEntries?.bookings?.paid &&
                                            seatEntries?.bookings?.paid?.details?.length ? (
                                              <div className="relative block-info-booking">
                                                <Badge count={seatEntries?.bookings?.paid?.details?.length}>
                                                  <img
                                                    src={IconPayment}
                                                    alt=""
                                                    onMouseOver={() =>
                                                      setIsHoveredPayment(seatEntries?.bookings?.paid?.details[0]?.id)
                                                    }
                                                    onMouseOut={() => setIsHoveredPayment('')}
                                                  />
                                                </Badge>
                                                {isHoveredPayment === seatEntries?.bookings?.paid?.details[0]?.id && (
                                                  <div className="hover-info">
                                                    {seatEntries?.bookings?.paid?.details &&
                                                      seatEntries?.bookings?.paid?.details?.map(
                                                        (booking: any, index: number) => (
                                                          <Flex gap={16} align="center" key={`booking-${index}`}>
                                                            <Flex align="start" justify="center" className="flex-col">
                                                              <p className="fs-16 fw-500 text-blue">
                                                                {booking?.ticket_code}
                                                              </p>
                                                              <img
                                                                src={imageStatusTicket(booking, true, false, false)}
                                                                alt=""
                                                              />
                                                            </Flex>
                                                            <div className="max-content">
                                                              <p className="fs-16 fw-500 text-blue">
                                                                {booking?.customer_name}
                                                              </p>
                                                              <p className="fs-14 fw-500 text-light-blue">{`${booking?.start_location} - ${booking?.end_location}`}</p>
                                                            </div>
                                                          </Flex>
                                                        ),
                                                      )}
                                                  </div>
                                                )}
                                              </div>
                                            ) : (
                                              <></>
                                            )}
                                          </Space>

                                          <Space size="middle">
                                            {seatEntries?.bookings?.open_api &&
                                            seatEntries?.bookings?.open_api?.details?.length ? (
                                              <div className="relative block-info-booking">
                                                <Badge count={seatEntries?.bookings?.open_api?.details?.length}>
                                                  <img
                                                    src={IconOpenApi}
                                                    alt=""
                                                    onMouseOver={() =>
                                                      setIsHoveredOpenApi(
                                                        seatEntries?.bookings?.open_api?.details[0]?.id,
                                                      )
                                                    }
                                                    onMouseOut={() => setIsHoveredOpenApi('')}
                                                  />
                                                </Badge>
                                                {isHoveredOpenApi ===
                                                  seatEntries?.bookings?.open_api?.details[0]?.id && (
                                                  <div className="hover-info">
                                                    {seatEntries?.bookings?.open_api?.details &&
                                                      seatEntries?.bookings?.open_api?.details?.map(
                                                        (booking: any, index: number) => (
                                                          <Flex gap={16} align="center" key={`booking-${index}`}>
                                                            <div>
                                                              <p className="fs-16 fw-500 text-blue"></p>
                                                              <img
                                                                src={imageStatusTicket(booking, false, false, true)}
                                                                alt=""
                                                              />
                                                            </div>
                                                            <div className="max-content">
                                                              <p className="fs-16 fw-500 text-blue">
                                                                {booking?.customer_name}
                                                              </p>
                                                              <p className="fs-14 fw-500 text-light-blue">{`${booking?.start_location} - ${booking?.end_location}`}</p>
                                                            </div>
                                                          </Flex>
                                                        ),
                                                      )}
                                                  </div>
                                                )}
                                              </div>
                                            ) : (
                                              <></>
                                            )}
                                          </Space>
                                        </Flex>
                                      ) : (
                                        <></>
                                      )}
                                      {seatFloors?.type < Constant.NORMAL_SEAT && (
                                        <Typography className="fw-600 mt-1">
                                          {seatCustomerEntries?.customer_name}
                                        </Typography>
                                      )}
                                    </div>
                                    {seatEntries?.new_booking?.customer && isShowNewBooking ? (
                                      <div className="mt-3 customer-info-ticket">
                                        {listBooking?.count_segment !== 1 ? (
                                          <p className="fs-16 fw-600 text-blue">{`${
                                            seatEntries?.new_booking?.customer
                                          } (${
                                            seatEntries?.bookings?.open_api?.details?.length
                                              ? 'N/A'
                                              : seatEntries?.new_booking?.phone
                                          })`}</p>
                                        ) : (
                                          <div>
                                            <p className="fs-16 fw-600 text-blue">{`${seatEntries?.new_booking?.customer}`}</p>
                                            <Flex align="center" gap={8} className="mt-1">
                                              <p className="fs-16 fw-500 text-blue">
                                                {seatEntries?.bookings?.open_api?.details?.length
                                                  ? 'N/A'
                                                  : seatEntries?.new_booking?.phone}
                                              </p>
                                              {seatEntries?.total_paid ||
                                              seatEntries?.bookings?.paid?.details?.length ? (
                                                <img
                                                  src={
                                                    seatEntries?.new_booking?.payer?.company?.id
                                                      ? iconCarGroup
                                                      : iconAgent
                                                  }
                                                  alt=""
                                                />
                                              ) : seatEntries?.bookings?.open_api?.details?.length ? (
                                                <img src={iconOpenApi} alt="" />
                                              ) : seatEntries?.new_booking?.orderer?.company?.id ? (
                                                <img src={iconCompanyReserve} alt="" />
                                              ) : (
                                                <img src={iconAgentReserve} alt="" />
                                              )}
                                            </Flex>
                                          </div>
                                        )}
                                        {listBooking?.count_segment !== 1 ? (
                                          <Flex gap={8} align="center" className="mt-1">
                                            <img src={iconNew} alt="" />
                                            <p className="fs-14 fw-500 text-blue">{`${seatEntries?.new_booking?.start_location} - ${seatEntries?.new_booking?.end_location}`}</p>
                                          </Flex>
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    ) : (
                                      ''
                                    )}

                                    {listBooking?.count_segment === 1 && seatEntries ? (
                                      <div className="address-bus fw-500 fs-14 mt-2">
                                        <Typography className="fs-14">
                                          {seatEntries?.new_booking?.pickup_location?.location_name
                                            ? `${
                                                seatEntries?.new_booking?.pickup_location?.location_name
                                              } (${seatEntries?.new_booking?.pickup_location?.time?.slice(0, 5)}${
                                                (seatEntries?.new_booking?.pickup_location?.diff_day ||
                                                  seatEntries?.new_booking?.drop_off_location?.diff_day) > 0
                                                  ? ` - ${dayjs(listBooking?.travel_info?.depart_date)
                                                      ?.add(seatEntries?.new_booking?.pickup_location?.diff_day, 'day')
                                                      ?.format(DateFormat)}`
                                                  : ''
                                              })`
                                            : listBooking?.schedule?.depart_date === listBooking?.schedule?.arrive_date
                                            ? `${
                                                seatEntries?.new_booking?.pickup_extra
                                              } (${listBooking?.schedule?.depart_time?.slice(0, 5)})`
                                            : `${
                                                seatEntries?.new_booking?.pickup_extra
                                              } (${listBooking?.schedule?.depart_time?.slice(0, 5)} - ${
                                                listBooking?.schedule?.depart_date
                                              })`}
                                        </Typography>
                                        <Typography className="fs-14">
                                          {seatEntries?.new_booking?.drop_off_location?.location_name
                                            ? `${
                                                seatEntries?.new_booking?.drop_off_location?.location_name
                                              } (${seatEntries?.new_booking?.drop_off_location?.time?.slice(0, 5)}${
                                                (seatEntries?.new_booking?.pickup_location?.diff_day ||
                                                  seatEntries?.new_booking?.drop_off_location?.diff_day) > 0
                                                  ? ` - ${dayjs(listBooking?.travel_info?.depart_date)
                                                      ?.add(
                                                        seatEntries?.new_booking?.drop_off_location?.diff_day,
                                                        'day',
                                                      )
                                                      ?.format(DateFormat)}`
                                                  : ''
                                              })`
                                            : listBooking?.schedule?.depart_date === listBooking?.schedule?.arrive_date
                                            ? `${
                                                seatEntries?.new_booking?.drop_off_extra
                                              } (${listBooking?.schedule?.arrive_time?.slice(0, 5)})`
                                            : `${
                                                seatEntries?.new_booking?.drop_off_extra
                                              } (${listBooking?.schedule?.arrive_time?.slice(0, 5)} - ${
                                                listBooking?.schedule?.arrive_date
                                              })`}
                                        </Typography>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    {listBooking?.count_segment === 1 && seatEntries?.new_booking?.note ? (
                                      <div className="note fw-500 fs-14 mt-2">
                                        <Typography className="fs-14">
                                          {`*${seatEntries?.new_booking?.note}`}
                                        </Typography>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    <div className={`${seatEntries?.customer?.name ? '' : 'price-item'} mb-18 mt-3`}>
                                      {seatEntries && !listBookingRender?.contract?.id ? (
                                        <>
                                          {(listBooking?.count_segment === 1 && seatEntries?.total_paid) ||
                                          listBooking?.count_segment !== 1 ? (
                                            <div className="d-flex gap-x-2 items-center">
                                              <img src={iconPaid} alt="" />
                                              <p className="text-blue fs-14 fw-600">
                                                {' '}
                                                {` ${
                                                  seatEntries && seatEntries?.total_paid
                                                    ? formattedPrice(seatEntries?.total_paid)
                                                    : 0
                                                } VND`}
                                              </p>
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                          {(listBooking?.count_segment === 1 && seatEntries?.total_reserve) ||
                                          listBooking?.count_segment !== 1 ? (
                                            <div className="d-flex gap-x-2 items-center mt-1">
                                              <img src={iconUnPaid} alt="" />
                                              <p className="text-blue fs-14 fw-500">
                                                {` ${
                                                  seatEntries && seatEntries?.total_reserve
                                                    ? formattedPrice(seatEntries?.total_reserve)
                                                    : 0
                                                } VND`}
                                              </p>
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                        </>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  </>
                                )}

                                <div className="btn-diagram-block">
                                  {seatEntries?.status === 'locked' || (isLocked && !seatEntries) ? (
                                    ''
                                  ) : seatFloors?.type > Constant.EXTRA_DRIVER_SEAT ? (
                                    <>
                                      {seatEntries && !seatEntries?.is_lock && selectedSeatNames?.length < 2 ? (
                                        <>
                                          {((listBooking?.trip?.status !== 'departed' &&
                                            listBooking?.trip?.status !== 'canceled') ||
                                            !isBooking) &&
                                          (group !== USER_GROUP.AGENT ||
                                            (group === USER_GROUP.AGENT &&
                                              searchDateBooking &&
                                              listBooking?.booked_seat?.includes(seatFloors?.name) &&
                                              !isLocked)) &&
                                          listBooking?.count_segment !== 1 ? (
                                            <Button
                                              className={`btn-diagram ${
                                                (seatEntries && !seatEntries?.is_available) || isWaitingCustomerList
                                                  ? 'disable'
                                                  : ''
                                              }`}
                                              disabled={
                                                (seatEntries && !seatEntries?.is_available) ||
                                                isWaitingCustomerList ||
                                                (listAssistBooking?.length &&
                                                  listFreeSeat?.length &&
                                                  !listFreeSeat?.includes(seatFloors?.name))
                                              }
                                              onClick={() => handleCreateBooking(seatFloors?.name, rowIndex, colIndex)}
                                            >
                                              <Tooltip title={'Đặt vé'} key={'bkt'} placement="right">
                                                <img
                                                  src={
                                                    (seatEntries && !seatEntries?.is_available) || isWaitingCustomerList
                                                      ? IconBan
                                                      : iconBooking
                                                  }
                                                  alt=""
                                                />
                                              </Tooltip>
                                            </Button>
                                          ) : (
                                            ''
                                          )}
                                          {listBooking?.contract?.code ? (
                                            ''
                                          ) : listBooking?.count_segment === 1 ? (
                                            <>
                                              <Button
                                                className="btn-diagram"
                                                onClick={() =>
                                                  handleEditBooking(
                                                    'Chỉnh sửa',
                                                    getInfoSingleDetail(seatEntries)?.ticket_code,
                                                    getInfoSingleDetail(seatEntries)?.id,
                                                    getInfoSingleDetail(seatEntries),
                                                    seatFloors?.name
                                                  )
                                                }
                                              >
                                                <Tooltip title="Chỉnh sửa" placement="top">
                                                  <img src={IcEditTicket} alt={''} />
                                                </Tooltip>
                                              </Button>
                                              <Button
                                                className="btn-diagram"
                                                onClick={() =>
                                                  handleEditBooking(
                                                    'Chuyển vé',
                                                    getInfoSingleDetail(seatEntries)?.ticket_code,
                                                    getInfoSingleDetail(seatEntries)?.id,
                                                    getInfoSingleDetail(seatEntries),
                                                    seatFloors?.name,
                                                  )
                                                }
                                              >
                                                <Tooltip title={'Chuyển vé'} placement="top">
                                                  <img src={IcMoveTicket} alt="" />
                                                </Tooltip>
                                              </Button>
                                              <Button
                                                className="btn-diagram"
                                                onClick={() =>
                                                  handleEditBooking(
                                                    'In vé',
                                                    getInfoSingleDetail(seatEntries)?.ticket_code,
                                                    getInfoSingleDetail(seatEntries)?.id,
                                                    getInfoSingleDetail(seatEntries),
                                                    seatFloors?.name

                                                  )
                                                }
                                              >
                                                <Tooltip title={'In vé'} placement="top">
                                                  <img src={IcPrintTicket} alt={''} />
                                                </Tooltip>
                                              </Button>
                                              <Button
                                                className="btn-diagram"
                                                onClick={() =>
                                                  handleEditBooking(
                                                    'Gửi mail',
                                                    getInfoSingleDetail(seatEntries)?.ticket_code,
                                                    getInfoSingleDetail(seatEntries)?.id,
                                                    getInfoSingleDetail(seatEntries),
                                                    seatFloors?.name
                                                  )
                                                }
                                              >
                                                <Tooltip title={'Gửi mail'} placement="top">
                                                  <img src={IcSendMail} alt={''} />
                                                </Tooltip>
                                              </Button>
                                            </>
                                          ) : (
                                            <Button
                                              className="btn-diagram"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                getDetailBooking(seatFloors?.name);
                                              }}
                                            >
                                              <Tooltip title={'Chỉnh sửa'} key={'edt2'} placement="right">
                                                <img src={IcEdit} alt="" />
                                              </Tooltip>
                                            </Button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {seatEntries?.new_booking && isWaitingCustomerList ? (
                                            <Button
                                              className="btn-diagram"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                getDetailBooking(seatFloors?.name);
                                              }}
                                              // onClick={() => getDetailBooking(seatFloors?.name)}
                                            >
                                              <Tooltip title={'Chỉnh sửa'} key={'edt2'} placement="right">
                                                <img src={IcEdit} alt="" />
                                              </Tooltip>
                                            </Button>
                                          ) : (
                                            ''
                                          )}
                                          {selectedSeatNames?.length > 1 &&
                                          selectedSeatNames.find((selected: any) => selected === seatFloors?.name) &&
                                          (listBooking?.trip?.status !== 'departed' || !isBooking) &&
                                          // !seatEntries &&
                                          ((!isOpenBus && listBooking?.trip?.status !== 'canceled') || isOpenBus) &&
                                          !(
                                            dateSelect > dayjs(listBooking?.schedule?.open_before_day) ||
                                            listBooking?.schedule?.open_before === 0
                                          ) &&
                                          (group !== USER_GROUP.AGENT ||
                                            (group === USER_GROUP.AGENT &&
                                              searchDateBooking &&
                                              !listBooking?.booked_seat?.includes(seatFloors?.name) &&
                                              !isLocked)) ? (
                                            <>
                                              <>
                                                {seatEntries &&
                                                selectedSeatNames?.length >1 &&
                                                selectedSeatNames?.includes(seatFloors?.name) &&
                                                !isWaitingCustomerList ? (
                                                  <Button
                                                    className="btn-diagram"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleChangeBooking(selectedSeatNames);
                                                    }}
                                                  >
                                                    <Tooltip title={'Chuyển vé'} key={'edt2'} placement="right">
                                                      <img src={IcMoveTicket} alt="" />
                                                    </Tooltip>
                                                  </Button>
                                                ) : (
                                                  ''
                                                )}
                                              </>
                                              {checkAvailableSeat ? (
                                                <Button
                                                  className={`btn-diagram ${
                                                    (seatEntries && !seatEntries?.is_available) || isWaitingCustomerList
                                                      ? 'disable'
                                                      : ''
                                                  }`}
                                                  disabled={
                                                    (seatEntries && !seatEntries?.is_available) ||
                                                    isWaitingCustomerList ||
                                                    (listAssistBooking?.length &&
                                                      listFreeSeat?.length &&
                                                      !listFreeSeat?.includes(seatFloors?.name))
                                                  }
                                                  onClick={() =>
                                                    handleCreateMultiBooking(selectedSeatNames, rowIndex, colIndex)
                                                  }
                                                >
                                                  <Tooltip title={'Đặt vé'} key={'bkt'} placement="right">
                                                    <img
                                                      src={
                                                        (seatEntries && !seatEntries?.is_available) ||
                                                        isWaitingCustomerList
                                                          ? IconBan
                                                          : iconBooking
                                                      }
                                                      alt=""
                                                    />
                                                  </Tooltip>
                                                </Button>
                                              ) : (
                                                ''
                                              )}
                                              {group !== USER_GROUP.AGENT && !isWaitingCustomerList && (
                                                <Button
                                                  className="btn-diagram"
                                                  disabled={seatEntries?.status === 'hold'}
                                                  onClick={() => handleLockMultiBooking(selectedSeatNames)}
                                                >
                                                  <Tooltip title={'Khóa ghế'} key={'bkt-mt'} placement="right">
                                                    <img src={IcLock} alt="" />
                                                  </Tooltip>
                                                </Button>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {(listBooking?.trip?.status !== 'departed' || !isBooking) &&
                                                ((!isOpenBus && listBooking?.trip?.status !== 'canceled') ||
                                                  isOpenBus) &&
                                                !seatEntries?.is_lock &&
                                                !(listBooking?.schedule?.open_before_day
                                                  ? dateSelect > dayjs(listBooking?.schedule?.open_before_day) ||
                                                    listBooking?.schedule?.open_before === 0
                                                  : false) &&
                                                (group !== USER_GROUP.AGENT ||
                                                  (group === USER_GROUP.AGENT &&
                                                    (searchDateBooking &&
                                                    listBooking?.schedule?.agent_seats_custom &&
                                                    listBooking?.schedule?.agent_seats_custom[searchDateBooking]
                                                      ? listBooking?.schedule?.agent_seats_custom[
                                                          searchDateBooking
                                                        ]?.includes(seatFloors?.name) &&
                                                        !listBooking?.booked_seat?.includes(seatFloors?.name)
                                                      : listBooking?.schedule?.agent_seats?.includes(
                                                          seatFloors?.name,
                                                        )) &&
                                                    !listBooking?.booked_seat?.includes(seatFloors?.name))) && (
                                                  <Button
                                                    className={`btn-diagram ${
                                                      (seatEntries && !seatEntries?.is_available) ||
                                                      isWaitingCustomerList
                                                        ? 'disable'
                                                        : ''
                                                    }`}
                                                    disabled={
                                                      (seatEntries && !seatEntries?.is_available) ||
                                                      isWaitingCustomerList ||
                                                      (listAssistBooking?.length &&
                                                        listFreeSeat?.length &&
                                                        !listFreeSeat?.includes(seatFloors?.name))
                                                    }
                                                    onClick={() => {
                                                      if (
                                                        seatFloors.type > Constant.EXTRA_DRIVER_SEAT &&
                                                        seatFloors.name
                                                      ) {
                                                        if (!busTypeData?.[`floor2`][rowIndex][colIndex]?.selected) {
                                                          handleChangeTicket(rowIndex, colIndex, 2);
                                                        }

                                                        handleCreateBooking(seatFloors.name, rowIndex, colIndex);
                                                      }
                                                    }}
                                                  >
                                                    <Tooltip title={'Đặt vé'} key={'bkt2'} placement="right">
                                                      <img
                                                        src={
                                                          (seatEntries && !seatEntries?.is_available) ||
                                                          isWaitingCustomerList
                                                            ? IconBan
                                                            : iconBooking
                                                        }
                                                        alt=""
                                                      />
                                                    </Tooltip>
                                                  </Button>
                                                )}
                                              {group !== USER_GROUP.AGENT &&
                                                !isWaitingCustomerList &&
                                                !seatEntries?.is_lock &&
                                                !seatEntries &&
                                                (listBooking?.trip?.status !== 'departed' || !isBooking) &&
                                                ((!isOpenBus && listBooking?.trip?.status !== 'canceled') ||
                                                  isOpenBus) &&
                                                !(
                                                  dateSelect > dayjs(listBooking?.schedule?.open_before_day) ||
                                                  listBooking?.schedule?.open_before === 0
                                                ) && (
                                                  <Button
                                                    className="btn-diagram"
                                                    disabled={seatEntries?.status === 'hold'}
                                                    onClick={() => {
                                                      if (
                                                        seatFloors.type > Constant.EXTRA_DRIVER_SEAT &&
                                                        seatFloors.name
                                                      ) {
                                                        if (!busTypeData?.[`floor2`][rowIndex][colIndex]?.selected) {
                                                          handleChangeTicket(rowIndex, colIndex, 2);
                                                        }
                                                        handleLockBooking(seatFloors.name);
                                                      }
                                                    }}
                                                  >
                                                    <Tooltip title={'Khóa ghế'} key={'lock3'} placement="right">
                                                      <img src={IcLock} alt="" />
                                                    </Tooltip>
                                                  </Button>
                                                )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  ) : seatFloors.type === Constant.DRIVER_SEAT ||
                                    seatFloors.type === Constant.EXTRA_DRIVER_SEAT ? (
                                    ''
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                {listBooking?.count_segment === 1 &&
                                listBooking?.price_schedule?.reason &&
                                seatFloors?.type > Constant.EXTRA_DRIVER_SEAT ? (
                                  <div className="price-schedule-block">
                                    {seatEntries?.new_booking?.price_schedule?.price ||
                                    seatEntries?.new_booking?.price_schedule?.percent ? (
                                      <p className="text-blue fs-13 fw-500">
                                        {getPriceScheduleReason(seatEntries?.new_booking?.price_schedule, false)}
                                      </p>
                                    ) : (
                                      <p className="text-blue fs-13 fw-500">
                                        {getPriceScheduleReason(listBooking?.price_schedule, false)}
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            }
                          />
                        </Col>
                      )
                    );
                  })}
                </Row>
              );
            })}
          </div>
        ) : (
          ''
        )}
      </Flex>
      <ModalHistoryBooking
        modalOpen={openModalHistory}
        onOk={() => setOpenModalHistory(false)}
        onCancel={cancelModalHistory}
        historyDetail={listBookingDetailSeat}
        listBooking={listBooking}
        isCancel={false}
      />
      <ModalPrintTicket
        modalOpen={openModalPrint}
        onCancel={cancelModalPrint}
        onOk={() => setOpenModalPrint(false)}
        listBooking={listBooking}
        listBookingDetailSeat={listBookingDetailSeat}
        listBookingDetail={listBookingDetail}
        // loading={loadingListBookingDetail}
      />
      <ModalBooking
        okText={'Lưu'}
        modalOpen={openModalBooking}
        onCancel={cancelModalBooking}
        cancelText={'Đóng'}
        onOk={handleOkModalBooking}
        listBooking={listBooking}
        formSearch={formSearch}
        isDetail={isDetail}
        listBookingDetail={listBookingDetail}
        loading={loading}
        // isDepart={isDepart}
        isBooking={isBooking}
        // isChangeTicket={isChangeTicket}
      />
      <ModalExportTicket
        modalOpen={openModalExportTicket}
        onOk={() => false}
        onCancel={() => setOpenModalExportTicket(false)}
        listBookingDetail={listBookingDetail}
        listBooking={listBooking}
        loadingDetailList={loadingDetailList}
        searchDateBooking={searchDateBooking}
      />
      <ModalChangeBooking
        okText={'Lưu'}
        modalOpen={openModalChangeBooking}
        onCancel={cancelChangBookingModal}
        cancelText={'Đóng'}
        onOk={handleOkChangeBooking}
        listBooking={listBooking}
        selectedSeatChangeBooking={selectedSeatChangeBooking}
        formSearch={formSearch}
        isDetail={isDetail}
        listBookingDetail={listBookingDetail}
        searchDateBooking={searchDateBooking}
      />
    </Spin>
  );
}

export default BusDiagramBookingRender;
